import { createSelector } from 'reselect';

const selectProgramHubs = (state: any) => state.programHubs;

export const selectProgramHubsCurrentItem = createSelector([selectProgramHubs], (programHubs) => programHubs.current);

export const selectProgramHubsListItems = createSelector([selectProgramHubs], (programHubs) => programHubs.list);

export const selectProgramHubsItemById = (itemId: any) =>
    createSelector(selectProgramHubsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProgramHubsQueryItems = createSelector([selectProgramHubs], (programHubs) => programHubs.query);

export const selectProgramHubsCreatedItem = createSelector([selectProgramHubs], (programHubs) => programHubs.create);

export const selectProgramHubsPublishedItem = createSelector([selectProgramHubs], (programHubs) => programHubs.publish);

export const selectProgramHubsUpdatedItem = createSelector([selectProgramHubs], (programHubs) => programHubs.update);

export const selectProgramHubsReadItem = createSelector([selectProgramHubs], (programHubs) => programHubs.read);

export const selectProgramHubsDeletedItem = createSelector([selectProgramHubs], (programHubs) => programHubs.delete);

export const selectProgramHubsSearchedItems = createSelector([selectProgramHubs], (programHubs) => programHubs.search);

export const selectProgramHubsItemsCount = createSelector([selectProgramHubs], (programHubs) => programHubs.count);

export const selectProgramHubsItemsFilter = createSelector([selectProgramHubs], (programHubs) => programHubs.filter);